import apiClient from "./apiClient";
const resource = "cleaning";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },

  async start(data) {
    apiClient.post(`${resource}/start`, data);
  },

  async finish(data) {
    apiClient.post(`${resource}/finish`, data);
  },
};
